import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
import { translate } from 'react-i18next'
import _ from 'lodash'

import { createProject, editProjectGeneral, selectProject } from '../../actions'

import { Form, Input, Button, Select, InputNumber } from 'antd'
const FormItem = Form.Item
const Option = Select.Option

class ProjectSettingsGeneral extends Component {
  handleSubmit = e => {
    e.preventDefault()
    const { form, project, user, editProjectGeneral, createProject } = this.props

    form.validateFields((err, values) => {
      if (!err) {
        if (project) {
          editProjectGeneral(project.id, user, values)
        } else {
          createProject(values, user, this.closeModalResetFields)
        }
      }
    })
  }

  closeModalResetFields = () => {
    const { form, selectProject } = this.props

    selectProject(null)
    form.resetFields()
  }

  render () {
    const {
      t,
      project,
      form: { getFieldDecorator },
      nav,
      loading,
      match: { params },
      selectProject,
      companies
    } = this.props

    // const myProjectRole = user.projectsRoles[project.id]

    // render Companies Options for antd Select element
    const companiesOptions = []
    _.map(companies, (company, companyId) =>
      companiesOptions.push(
        <Option key={companyId} value={companyId}>
          {companies[companyId].name}
        </Option>
      )
    )

    return (
      <Form onSubmit={this.handleSubmit}>

        <FormItem label='Name'>
          {getFieldDecorator('name', {
            initialValue: (project && project.name) || null,
            rules: [{ required: true, message: 'Please input the name of the new project' }]
          })(<Input />)}
        </FormItem>

        <FormItem label='Number of possible calls'>
          {getFieldDecorator('possibleCalls', {
            initialValue: (project && project.possibleCalls) || 3,
            rules: [{ required: true, message: 'possibleCalls is required' }]
          })(<InputNumber min={1} max={10} />)}
        </FormItem>

        <FormItem label='Description'>
          {getFieldDecorator('description', {
            initialValue: (project && project.description) || null
          })(<Input type='textarea' />)}
        </FormItem>

        <FormItem label='company'>
          {getFieldDecorator('companyId', {
            initialValue: (project && project.companyId) || null,
            rules: [{ required: true, message: 'Company is reqired' }]
          })(
            <Select>
              {companiesOptions}
            </Select>
          )}
        </FormItem>

        {/* if in Modal and editing */}
        {nav.project &&
          nav.project.action === 'edit' &&
          <Link to={`/project/${params.projectId}/settings`}>
            <Button style={{ marginBottom: 30 }} icon='setting' onClick={() => selectProject(null)}>
              More Settings
            </Button>
          </Link>}

        <FormItem>
          <Button
            htmlType='submit'
            type='primary'
            loading={nav.project && nav.project.action === 'edit' ? loading.editProjectGeneral : loading.createProject}
          >
            {nav.project ? t(`project.${nav.project.action}`) : 'Save'}
          </Button>
        </FormItem>

      </Form>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  nav: state.nav,
  loading: state.loading,
  user: state.user,
  companies: state.companies
})

const mapDispatchToParams = {
  createProject,
  editProjectGeneral,
  selectProject
}

export default connect(mapStateToProps, mapDispatchToParams)(
  Form.create()(translate('translations')(withRouter(ProjectSettingsGeneral)))
)



// WEBPACK FOOTER //
// ./src/components/ProjectSettings/ProjectSettingsGeneral.js